export interface TabPanelProps {
  children?: React.ReactNode;
  id: string;
  tabId: string;
  style: React.CSSProperties;
}

export default function TabPanel({ children, id, tabId, style }: TabPanelProps) {
  return (
    <div className="tabs__panel" role="tabpanel" id={id} aria-labelledby={tabId} style={style}>
      {children}
    </div>
  );
}
